import React from 'react';
import { BooleanInput, useRecordContext } from 'react-admin';
const BooleanInputAdd = (props) => {
  const record = useRecordContext();
  return (
    <BooleanInput {...props} helperText={record && record[props.source + '_add']}/>
  )
}

export default BooleanInputAdd;